import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from '@bd/bdui-styles/emotion';
import { typography, colors } from '../styles';

const styles = css`
  .PageSection_headerWrapper {
    text-align: center;
  }
  .PageSection_header {
    text-align: center;
    font-family: ${typography.Serif};
    font-size: 36px;
    line-height: 1;
    margin: 0 0 30px 0;
    display: inline-block;
    @media(min-width: 480px) {
      font-size: 48px;
      margin: 0 0 45px 0;
    }
    @media(min-width: 992px) {
      font-size: 60px;
      margin: 0 0 45px 0;
    }
    &::before {
      content: '';
      display: none;
      @media(min-width: 992px) {
        height: 10px;
        border-top: 2px solid ${colors.neutral};
        border-bottom: 2px solid ${colors.neutral};
        display: inline-block;
        width: 234px;
        margin: 0 15px 8px 0;
      }
    }
    &::after {
      content: '';
      display: block;
      width: 75px;
      height: 4px;
      border: 0;
      margin: 15px auto 0 auto;
      background-color: ${colors.brand4};
      @media(min-width: 992px) {
        display: inline-block;
        width: 234px;
        height: 10px;
        margin: 0 0 8px 15px;
        border-top: 2px solid ${colors.neutral};
        border-bottom: 2px solid ${colors.neutral};
        background-color: transparent;
      }
    }
  }
`;


function PageSectionHeader({ h2, h3, className }) {
  return (
    <div className={cx(styles, className)}>
      <div className="PageSection_headerWrapper">
        {h2 &&
          <h2 className="PageSection_header">{h2}</h2>
        }
        {h3 &&
          <h3 className="PageSection_header">{h3}</h3>
        }
      </div>
    </div>
  );
}

PageSectionHeader.propTypes = {
  h2: PropTypes.string,
  h3: PropTypes.string,
  className: PropTypes.string,
};

PageSectionHeader.defaultProps = {
  h2: undefined,
  h3: undefined,
  className: undefined,
};

export default PageSectionHeader;



// WEBPACK FOOTER //
// ./src/components/PageSectionHeading.js